export default __webpack_public_path__ + "static/media/widowmaker.80ad561b.webp";